import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import {Interval} from "@models";
import {useCallback} from "react";



function ReportsChart({data, interval=Interval.Hour,  intl}) {
  const {formatMessage, formatDate, formatTime} = intl;
  
  const getXValue = useCallback((date_time) => {
    let dateOptions = {};
    let time = "";
    switch (interval) {
      case Interval.Second:
        time = formatTime(date_time, { hour: 'numeric', minute: 'numeric', second: 'numeric'});
        break;
        
      case Interval.Minute:
        time = formatTime(date_time, { hour: 'numeric', minute: 'numeric'});
        break;
  
      case Interval.Hour:
        time = formatTime(date_time, { hour: 'numeric'});
        break;
  
      // case Interval.Day:
      //   dateOptions = {day:"numeric", month:"long", year:"numeric"};
      //   break;
  
      case Interval.Quarter:
        dateOptions = {year:"numeric", month:"long"};
        break;
  
      case Interval.Year:
        dateOptions = {year:"numeric"};
        break;
  
      default:
        formatDate(date_time);
    }
    
    return `${formatDate(date_time, dateOptions)} ${time}`
  }, [interval]);
  
  return(
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'spline'
          },
          title: {
            text: ''
          },
          xAxis: {
            // type: 'datetime',
            // dateTimeLabelFormats: { // don't display the dummy year
            //   month: '%e. %b',
            //   year: '%b'
            // },
            title: {
              text: ''
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: formatMessage({
                id: "app.view_count",
                defaultMessage: "View Count"
              })
            }
          },
          tooltip: {
            // headerFormat: '<b>{series.name}</b><br>',
            // pointFormat: '{point.x:%e. %b}: {point.y:.2f} m'
          },
  
          plotOptions: {
            series: {
              marker: {
                enabled: true
              }
            }
          },
  
          colors: ['#6CF', '#39F', '#06C', '#036', '#000'],
          series: [{
            name: "",
            data: data.map( item => [getXValue(item.date_time), item.total])
          }],
  
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500
              },
              // chartOptions: {
              //   plotOptions: {
              //     series: {
              //       marker: {
              //         radius: 2.5
              //       }
              //     }
              //   }
              // }
            }]
          }
        }}
      />
    </div>
  )
}

export default injectIntl(ReportsChart);

